import {
  calendar2Icon,
  calendarIcon,
  locationIcon,
  minusIcon,
  peopleIcon,
  perssonesIcon,
  plusIcon,
  settingIcon,
  phonecall,
  starIcon,
} from "../../assets/images/icons";
import Navbar from "../../components/Navbar/Navbar";
import Topbar from "../../components/Topbar/Topbar";
import "./hotel.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useEffect, useRef, useState } from "react";
import Footer from "../../components/Footer/Footer";
import React from "react";
import { hotelImage } from "../../assets/images/images";
import Hotelroom from "../../components/Hotelroom/Hotelroom";
import { useParams } from "react-router-dom";
import API from "../../API";
import { resolveImageUrl } from "../../constants";
import API2 from "../../API2";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { useTranslation } from 'react-i18next';

/* Subscribes to a media-query so we can render different markup per
   viewport instead of toggling visibility of two parallel trees. */
const useIsMobile = (breakpoint = 480) => {
  const get = () =>
    typeof window !== "undefined" && window.matchMedia(`(max-width: ${breakpoint}px)`).matches;
  const [isMobile, setIsMobile] = useState(get);
  useEffect(() => {
    if (typeof window === "undefined") return;
    const mq = window.matchMedia(`(max-width: ${breakpoint}px)`);
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener ? mq.addEventListener("change", handler) : mq.addListener(handler);
    return () => {
      mq.removeEventListener ? mq.removeEventListener("change", handler) : mq.removeListener(handler);
    };
  }, [breakpoint]);
  return isMobile;
};

/* One-card-at-a-time mobile carousel for hotel rooms. Mirrors the
   home-page `MobileCardCarousel` pattern (Swiper instance controlled
   imperatively via state to avoid double-binding). */
const MobileRoomsCarousel = ({ details, rates, realrate, propertyCode }) => {
  const [swiper, setSwiper] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  if (!details.length) return null;

  return (
    <div className="rooms_mobile_carousel">
      <Swiper
        modules={[]}
        spaceBetween={0}
        slidesPerView={1}
        onSwiper={setSwiper}
        onSlideChange={(s) => setActiveIndex(s.activeIndex)}
        observer={true}
        observeParents={true}
      >
        {details.map((detail, i) => (
          <SwiperSlide key={detail.id || i}>
            <Hotelroom rate={rates[0]} realrate={realrate} detail={detail} propertyCode={propertyCode} />
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="mcc-controls">
        <button
          type="button"
          className="mcc-arrow"
          aria-label="Previous"
          onClick={() => swiper && swiper.slidePrev()}
          disabled={activeIndex === 0}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <div className="mcc-pagination" role="tablist">
          {details.map((_, i) => (
            <button
              key={i}
              type="button"
              role="tab"
              aria-selected={activeIndex === i}
              aria-label={`Go to room ${i + 1}`}
              className={`mcc-dot ${activeIndex === i ? "is-active" : ""}`}
              onClick={() => swiper && swiper.slideTo(i)}
            />
          ))}
        </div>
        <button
          type="button"
          className="mcc-arrow"
          aria-label="Next"
          onClick={() => swiper && swiper.slideNext()}
          disabled={activeIndex === details.length - 1}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>
      </div>
    </div>
  );
};

// Fix for missing marker icons in Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default function Hotel() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const isMobile = useIsMobile(480);
  const [enfants, setEnfants] = useState(0);
  const [adults, setAdults] = useState(0);
  const [isExpanded, setIsExpanded] = useState(false);

  const { code } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [rates, setRates] = useState([]);
  const [realrate, setRealRate] = useState("");

  const mapRef = useRef(null);
  const [mapActive, setMapActive] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await API.get(`properties/one/${code}`);
        setData(response.data);
      } catch (err) {
        setError(err.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [code]);

  useEffect(() => {
    if (data && data.id) {
      const fetchData = async () => {
        try {
          setLoading(true);
          const response = await API2.get(`ratepricing/hotel/data/${data.id}`);
          console.log(response.data.rates_pricing_rules)
          setRealRate(response.data.rates_pricing_rules[0].rate.id);
          setRates(response.data.rates_pricing_rules[0].rate.details || []);
        } catch (err) {
          setError(err.message || "Something went wrong");
          setRates([]);
        } finally {
          setLoading(false);
        }
      };

      fetchData();
    }
  }, [data]);

  useEffect(() => {
    if (data?.latitude && data?.longitude && mapRef.current) {
      const map = mapRef.current;
      map.setView([data.latitude, data.longitude], 13);
    }
  }, [data?.latitude, data?.longitude]);

  const slideDownHandler = () => {
    setIsExpanded((state) => !state);
  };

  // Helper function to get the appropriate field based on language
  const getLocalizedField = (field, fieldAr) => {
    return isRTL && fieldAr ? fieldAr : field;
  };

  const services = (() => {
    if (Array.isArray(data?.services)) return data.services.map(s => typeof s === 'string' ? s : s.name || String(s));
    if (typeof data?.services === 'string') {
      try { const p = JSON.parse(data.services); return Array.isArray(p) ? p.map(s => typeof s === 'string' ? s : s.name || String(s)) : []; } catch { return []; }
    }
    return [];
  })();

  return (
    <div className={`Page_hotel ${isRTL ? 'rtl' : ''}`}>
      <Topbar />
      <Navbar />
      <div className="main">
        {/* ── HERO HEADER ── */}
        <div className="hotel_hero">
          <div className="hotel_hero_info">
            <div className="hotel_badge_row">
              <span className="hotel_type_badge">{data?.type || 'HOTEL'}</span>
              <div className="hotel_rating">
                <img src={starIcon} alt="star" />
                <span>4.6</span>
                <span className="hotel_rating_label">Excellent</span>
              </div>
            </div>
            <h1 className="hotel_name">{getLocalizedField(data?.name, data?.name_ar)}</h1>
            <div className="hotel_location_row">
              <img src={locationIcon} alt="location" />
              <span>{data ? `${data.location}` : "Loading location..."}</span>
            </div>
          </div>
          <div className="hotel_hero_price">
            <span className="price_label">{t("hotel.starting_from")}</span>
            <span className="price_amount">{data?.startprice ? Number(data.startprice).toLocaleString() : '10 000'}</span>
            <span className="price_unit">DA / {t("hotel.per_night")}</span>
          </div>
        </div>

        {/* ── IMAGE GALLERY ── */}
        <div className="hotel_gallery">
          <Swiper
            modules={[Pagination, Autoplay]}
            pagination={{ clickable: true, el: ".swiper-pagination", type: "bullets" }}
            style={{ width: "100%", height: "100%" }}
            autoplay={{ delay: 3000 }}
            loop={true}
          >
            {data?.images?.map((image, index) => (
              <SwiperSlide key={image.id}>
                <img
                  src={resolveImageUrl(image.url)}
                  alt={`Hotel ${index + 1}`}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </SwiperSlide>
            ))}
            <div className="swiper-pagination" />
          </Swiper>
        </div>

        {/* ── CONTENT GRID (description + sidebar) ── */}
        <div className="hotel_content_grid">
          <div className="hotel_content_main">
            <section className="hotel_section">
              <h2 className="section_title">{t("hotel.description")}</h2>
              <p className="section_text" dir={isRTL ? "rtl" : "ltr"}>
                {getLocalizedField(data?.description, data?.description_ar) || "Loading..."}
              </p>
            </section>

            <section className="hotel_section">
              <h2 className="section_title">{t("hotel.services")}</h2>
              <div className="amenities_grid">
                {services.length > 0 ? (
                  services.map((service, index) => (
                    <div className="amenity_item" key={index}>
                      <span className="amenity_check">✓</span>
                      <span>{service}</span>
                    </div>
                  ))
                ) : (
                  <p className="no-service">{t("hotel.no_services")}</p>
                )}
              </div>
            </section>
          </div>

          <aside className="hotel_sidebar">
            <div className="contact_card">
              <h3 className="card_title">Contact</h3>
              <div className="contact_row">
                <img src={phonecall} alt="phone" height={16} width={16} />
                <span>{data?.phonenumber || 'Loading...'}</span>
              </div>
              <div className="contact_row">
                <img src={locationIcon} alt="location" height={16} width={16} />
                <span>{data?.location || 'Loading...'}</span>
              </div>
            </div>

            <div className="booking_card">
              <span className="booking_label">{t("hotel.starting_from")}</span>
              <div className="booking_price">
                <span className="booking_amount">{data?.startprice ? Number(data.startprice).toLocaleString() : '10 000'} DA</span>
                <span className="booking_unit">/ {t("hotel.per_night")}</span>
              </div>
              <a href="#rooms" className="booking_cta">View Rooms</a>
            </div>
          </aside>
        </div>

        {/* ── ROOMS CAROUSEL + MAP ── */}
        <div className="rooms_map_grid" id="rooms">
          <section className="hotel_section rooms_section">
            <div className="section_header_row">
              <h2 className="section_title">{t("hotel.rates")}</h2>
              {!isMobile && rates.filter(d => d.room.available === true).length > 0 && (
                <div className="rooms_nav">
                  <button className="rooms_nav_btn rooms_prev">‹</button>
                  <button className="rooms_nav_btn rooms_next">›</button>
                </div>
              )}
            </div>
            {(() => {
              const available = rates.filter(d => d.room.available === true);
              if (available.length === 0) return <p>{t("hotel.no_rates")}</p>;
              return isMobile ? (
                <MobileRoomsCarousel
                  details={available}
                  rates={rates}
                  realrate={realrate}
                  propertyCode={code}
                />
              ) : (
                <Swiper
                  modules={[Navigation]}
                  navigation={{ prevEl: ".rooms_prev", nextEl: ".rooms_next" }}
                  spaceBetween={16}
                  slidesPerView={1}
                  breakpoints={{
                    640: { slidesPerView: 1.2 },
                    900: { slidesPerView: 1.5 },
                    1200: { slidesPerView: 2 },
                  }}
                  className="rooms_swiper"
                >
                  {available.map((detail, index) => (
                    <SwiperSlide key={detail.id || index}>
                      <Hotelroom rate={rates[0]} realrate={realrate} detail={detail} propertyCode={code} />
                    </SwiperSlide>
                  ))}
                </Swiper>
              );
            })()}
          </section>

          <section className="hotel_section map_section">
            <div className="section_header_row">
              <h2 className="section_title">{t("hotel.on_map")}</h2>
              {data?.latitude && data?.longitude && (
                <a
                  className="open_maps_link"
                  href={`https://www.google.com/maps/search/?api=1&query=${data.latitude},${data.longitude}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Open in Google Maps ↗
                </a>
              )}
            </div>
            <div
              className="map_location"
              onMouseLeave={() => setMapActive(false)}
            >
              <MapContainer
                ref={mapRef}
                center={data?.latitude && data?.longitude ? [data.latitude, data.longitude] : [36.1911, 5.4137]}
                zoom={14}
                style={{ height: "100%", width: "100%", borderRadius: "12px" }}
                whenCreated={(mapInstance) => (mapRef.current = mapInstance)}
                scrollWheelZoom={mapActive}
              >
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                />
                {data?.latitude && data?.longitude && (
                  <Marker position={[data.latitude, data.longitude]}>
                    <Popup>
                      <strong>{getLocalizedField(data?.name, data?.name_ar)}</strong><br />
                      {data.location}
                    </Popup>
                  </Marker>
                )}
              </MapContainer>
              {!mapActive && (
                <div
                  className="map_overlay"
                  onClick={() => setMapActive(true)}
                >
                  <span>Click to enable zoom</span>
                </div>
              )}
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
}